import React from "react";
import StyledCheckbox from "@/src/components/form/checkbox/StyledCheckbox";
import { useFormContext } from "react-hook-form";
import { Body7 } from "@/src/components/typography/components/Body";
import { TokenTransferRequestFieldNames } from "../../../hooks/constants";

export default function LegalTermsCheckbox() {
  const { register } = useFormContext();

  return (
    <StyledCheckbox
      id="terms"
      {...register(TokenTransferRequestFieldNames.legalAgreement, {
        required: true,
      })}
      required
      classes={{ label: "min-h-7" }}
    >
      <Body7 className="pl-1 laptop:pl-0 laptop:pt-1">
        I agree to the transfer of Nike Virtual Creations to the below address
      </Body7>
    </StyledCheckbox>
  );
}
